export default function truncate_chars(str, n = 30, terminator = "…") {
    if (str && str.length > n) {
        return str.substring(0, n) + terminator
    }
    return str
}
